<template>
  <figure
    class="text-sm text-vdv-border-dark w-fit"
    style="height: auto !important"
  >
    <VideoBasic :video-data="videoData" :class="props.videoClasses" />
    <figcaption
      v-if="videoData[isMobile ? 'mobile' : 'desktop'].copyright == null"
      class="text-center mt-xs px-sm sm:px-0"
    >
      <b>{{ videoData[isMobile ? 'mobile' : 'desktop'].title }}</b>
    </figcaption>
    <figcaption v-else class="text-center mt-xs px-sm sm:px-0">
      <i
        ><b>{{ videoData[isMobile ? 'mobile' : 'desktop'].title }} </b></i
      >
      - &#169; {{ videoData[isMobile ? 'mobile' : 'desktop'].copyright }}
    </figcaption>
    <div
      v-show="
        videoData[isMobile ? 'mobile' : 'desktop'].shortDescription != null &&
        isMobile == false
      "
      class="text-center"
    >
      <i>{{ videoData[isMobile ? 'mobile' : 'desktop'].shortDescription }}</i>
    </div>
  </figure>
</template>

<script setup lang="ts">
import VideoBasic from '@/components/components/core/videoBasic/video-basic.vue';
import { mq_breakpointIsMobile } from '@/injectionSymbols';
import type { BasicVideoData } from '~~/src/components/components/core/videoBasic/type';

const isMobile = inject(mq_breakpointIsMobile);

const props = defineProps({
  videoData: {
    type: Object as PropType<BasicVideoData>,
    required: true,
  },
  videoClasses: {
    type: String,
    required: false,
    default: '',
  },
});
</script>

<style scoped lang="postcss"></style>
